import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { cond, always, either, isNil, isEmpty } from 'ramda'
import withFieldError from 'components/form/with-error'
import { SelectPickerField } from 'components/form/selectpicker'
import CustomDmTemplate from './custom-template'

const selector = formValueSelector('widget')

export const validate = cond([
  [either(isEmpty, isNil), always('Please enter a Post ID')]
])

export const TextMessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

TextMessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const TextMessageInputWithError = withFieldError(TextMessageInput)

export const FacebookSendBlastFields = ({ name, selectedAction }) => (
  <div className='row select-group'>
    <div className='col-sm-4 br-no-pad-right component-select-picker'>
      <Field
        name={`${name}.action`}
        component={SelectPickerField}
        defaultValue='TEMPLATE_GENERIC'
      >
        <option value='TEMPLATE_GENERIC'>Generic DM Template</option>
        <option value='TEMPLATE_CUSTOM'>Custom Template</option>
      </Field>
    </div>

    {selectedAction === 'TEMPLATE_GENERIC' && (
      <div className='col-sm-12'>
        <Field
          component={TextMessageInputWithError}
          label='Message'
          name={`${name}.blastText`}
          placeholder='Blast text'
          require
        />
        <Field
          component={TextMessageInputWithError}
          label='Image URL'
          name={`${name}.blastImageUrl`}
          placeholder='Blast Message Hosted Image URL'
        />
        <Field
          component={TextMessageInputWithError}
          label='Template Title'
          name={`${name}.blastTemplateTitle`}
          placeholder='Blast Message Template Heading'
        />
        <Field
          component={TextMessageInputWithError}
          label='Template Action URL'
          name={`${name}.blastTemplateActionUrl`}
          placeholder='Template Action URL'
        />
      </div>
    )}
    {selectedAction === 'TEMPLATE_CUSTOM' && (
      <div className='br-has-checkbox col-sm-12'>
        <Field component={CustomDmTemplate} name={`${name}.customDmTemplate`} />
      </div>
    )}
  </div>
)

FacebookSendBlastFields.propTypes = {
  name: PropTypes.string,
  selectedAction: PropTypes.string
}

const FacebookSendBlastWithType = connect((state, props) => ({
  selectedAction: selector(state, `${props.name}.action`)
}))(FacebookSendBlastFields)

export default FacebookSendBlastWithType



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/facebook/send-facebook-blast/index.js